import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/customer/Landing";
import BookWizard from "@/pages/customer/BookWizard";
import Track from "@/pages/customer/Track";
import PayRetry from "@/pages/customer/PayRetry";
import VerifyWorker from "@/pages/VerifyWorker";
import { SeoHead } from "@/seo/SeoHead";
import CustomerLogin from "@/pages/customer/Login";
import CustomerRegister from "@/pages/customer/Register";
import WorkerRegister from "@/pages/worker/Register";
import WorkerLogin from "@/pages/worker/Login";
import WorkerDashboard from "@/pages/worker/Dashboard";
import AdminLogin from "@/pages/admin/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminApp from "@/pages/admin/AdminApp";
import FranchiseApply from "@/pages/franchise/Apply";
import FranchiseLogin from "@/pages/franchise/Login";
import FranchiseDashboard from "@/pages/franchise/Dashboard";

function AppRoutes() {
  const loc = useLocation();
  // CRITICAL: Google callback may land on ANY route with #session_id — route it synchronously to our callback handler
  if (loc.hash && loc.hash.includes("session_id=") && loc.pathname !== "/auth/callback") {
    return <AuthCallback />;
  }
  return (
    <>
    <SeoHead />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/book" element={<BookWizard />} />
      <Route path="/track" element={<Track />} />
      <Route path="/pay/:token" element={<PayRetry />} />
      <Route path="/verify" element={<VerifyWorker />} />
      <Route path="/verify/:code" element={<VerifyWorker />} />
      <Route path="/customer/login" element={<CustomerLogin />} />
      <Route path="/customer/register" element={<CustomerRegister />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/worker/register" element={<WorkerRegister />} />
      <Route path="/worker/login" element={<WorkerLogin />} />
      <Route path="/worker/dashboard" element={<WorkerDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/franchise/apply" element={<FranchiseApply />} />
      <Route path="/franchise/login" element={<FranchiseLogin />} />
      <Route path="/franchise/dashboard" element={<FranchiseDashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
